<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <form @submit.prevent="save()">
            <div class="card-body">
              <h5 class="mb-3">Moedas</h5>
              <div class="row">
                <div class="col-sm-4">
                  <label for="base_currency">Moeda base</label>
                  <select
                    id="base_currency"
                    class="custom-select"
                    v-model="settings.base_currency">
                    <option v-for="c in availableCurrencies" :key="c" :value="c">{{ c }}</option>
                  </select>
                  <small class="text-muted">Moeda usada nos totais e relatórios.</small>
                </div>
                <div class="col-sm-8">
                  <label>Moedas habilitadas para lançamentos</label>
                  <div class="d-flex flex-wrap">
                    <div
                      v-for="c in availableCurrencies"
                      :key="'en-' + c"
                      class="custom-control custom-checkbox mr-3 mb-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'en-' + c"
                        :value="c"
                        v-model="settings.enabled_currencies">
                      <label class="custom-control-label" :for="'en-' + c">{{ c }}</label>
                    </div>
                  </div>
                  <small class="text-muted">A moeda base é sempre incluída automaticamente.</small>
                </div>
              </div>

              <hr class="my-4">

              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Categorias</h5>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="addCategory()">
                  <i class="mdi mdi-plus"></i> Adicionar
                </button>
              </div>
              <p v-if="!settings.categories.length" class="text-muted">Nenhuma categoria cadastrada.</p>
              <table v-else class="table table-sm align-middle">
                <thead>
                  <tr>
                    <th style="width:90px">Ordem</th>
                    <th>Nome</th>
                    <th style="width:140px">Ativo</th>
                    <th style="width:60px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in settings.categories" :key="'cat-' + i">
                    <td>
                      <input type="number" class="form-control form-control-sm" v-model.number="item.sort_order">
                    </td>
                    <td>
                      <input type="text" class="form-control form-control-sm" v-model="item.name" placeholder="Ex: Seguro">
                    </td>
                    <td>
                      <select class="custom-select custom-select-sm" v-model="item.active">
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        @click="removeCategory(i)"
                        title="Remover">
                        <i class="mdi mdi-trash-can-outline"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <hr class="my-4">

              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Formas de pagamento</h5>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="addPaymentMethod()">
                  <i class="mdi mdi-plus"></i> Adicionar
                </button>
              </div>
              <p v-if="!settings.payment_methods.length" class="text-muted">Nenhuma forma de pagamento cadastrada.</p>
              <table v-else class="table table-sm align-middle">
                <thead>
                  <tr>
                    <th style="width:90px">Ordem</th>
                    <th>Nome</th>
                    <th style="width:140px">Ativo</th>
                    <th style="width:60px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in settings.payment_methods" :key="'pm-' + i">
                    <td>
                      <input type="number" class="form-control form-control-sm" v-model.number="item.sort_order">
                    </td>
                    <td>
                      <input type="text" class="form-control form-control-sm" v-model="item.name" placeholder="Ex: PIX">
                    </td>
                    <td>
                      <select class="custom-select custom-select-sm" v-model="item.active">
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                      </select>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        @click="removePaymentMethod(i)"
                        title="Remover">
                        <i class="mdi mdi-trash-can-outline"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="card-footer text-right">
              <button type="submit" class="btn btn-primary" :disabled="saving">
                <span v-if="saving">Salvando...</span>
                <span v-else>Salvar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'setting-financial-control',
  data () {
    return {
      title: 'Controle Financeiro',
      items: [
        { text: 'Configurações' },
        { text: 'Controle Financeiro', active: true }
      ],
      availableCurrencies: ['BRL', 'USD', 'EUR', 'GBP', 'ARS', 'CLP'],
      saving: false
    }
  },
  computed: {
    ...mapState('financialControl', ['settings'])
  },
  mounted () {
    const loader = this.$loading.show()
    this.GetFinancialSettings().finally(() => loader.hide())
  },
  watch: {
    'settings.base_currency' (val) {
      if (val && !this.settings.enabled_currencies.includes(val)) {
        this.settings.enabled_currencies.push(val)
      }
    }
  },
  methods: {
    ...mapActions('financialControl', ['GetFinancialSettings', 'SaveFinancialSettings']),
    addCategory () {
      this.settings.categories.push({
        name: '',
        active: true,
        sort_order: (this.settings.categories.length + 1)
      })
    },
    removeCategory (index) {
      this.settings.categories.splice(index, 1)
    },
    addPaymentMethod () {
      this.settings.payment_methods.push({
        name: '',
        active: true,
        sort_order: (this.settings.payment_methods.length + 1)
      })
    },
    removePaymentMethod (index) {
      this.settings.payment_methods.splice(index, 1)
    },
    async save () {
      this.saving = true
      try {
        const payload = {
          base_currency: this.settings.base_currency,
          enabled_currencies: this.settings.enabled_currencies,
          categories: this.settings.categories.filter(c => c.name && c.name.trim() !== ''),
          payment_methods: this.settings.payment_methods.filter(p => p.name && p.name.trim() !== '')
        }
        await this.SaveFinancialSettings(payload)
        successMessage('Configurações atualizadas com sucesso.', 2000)
      } catch (e) {
        const msg = e?.response?.data?.message || 'Falha ao salvar configurações.'
        errorMessage(msg, 3000)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
